<template>
    <router-view/>
</template>
<script>
export default {
    name: "client-games-aggregators",
}
</script>
<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/components/clients/client/games/aggregators.vue